import { RequestQueryBuilder } from "@nestjsx/crud-request";
import { setHours, setMinutes } from "date-fns";
import format from "date-fns/format";
import qs from "query-string";

import { IRange } from "../../../core/models";

export interface ITransactionFilter {
  createdDateRange?: IRange<Date>;
  clientId: string;
  productId: string;
  expenseId: string;
  type: string;
}

export function filterToQueryParams(filter: ITransactionFilter): string {
  const qb = RequestQueryBuilder.create();

  if (filter.createdDateRange?.from) {
    qb.setFilter({
      field: "createdDate",
      operator: "$gte",
      value: format(setMinutes(setHours(filter.createdDateRange?.from, 0), 0), "yyyy-MM-dd HH:mm"),
    });
  }

  if (filter.createdDateRange?.to) {
    qb.setFilter({
      field: "createdDate",
      operator: "$lte",
      value: format(setMinutes(setHours(filter.createdDateRange?.to, 23), 59), "yyyy-MM-dd HH:mm"),
    });
  }

  if (filter.clientId) {
    qb.setFilter({
      field: "client",
      operator: "$eq",
      value: filter.clientId,
    });
  }

  if (filter.productId) {
    qb.setFilter({
      field: "product",
      operator: "$eq",
      value: filter.productId,
    });
  }

  if (filter.expenseId) {
    qb.setFilter({
      field: "expense",
      operator: "$eq",
      value: filter.expenseId,
    });
  }

  if (filter.type) {
    qb.setFilter({
      field: "type",
      operator: "$eq",
      value: filter.type,
    });
  }

  qb.sortBy({ field: "id", order: "DESC" });

  return qb.query(false);
}

export function queryParamsToFilter(queryString: string): ITransactionFilter {
  const queryParams = qs.parse(queryString);
  const filter: ITransactionFilter = {
    clientId: "",
    productId: "",
    expenseId: "",
    type: "",
  };

  Object.keys(queryParams).forEach((key) => {
    if (key.includes("filter")) {
      const query = queryParams[key]?.toString();

      if (query) {
        const parsed = query.split("||");
        const filterKey = parsed[0];
        const condition = parsed[1];
        const filterValue = parsed[2];

        if (filterKey === "client") {
          filter.clientId = filterValue;
        } else if (filterKey === "product") {
          filter.productId = filterValue;
        } else if (filterKey === "expense") {
          filter.expenseId = filterValue;
        } else if (filterKey === "type") {
          filter.type = filterValue;
        } else if (filterKey === "createdDate" && condition === "$gte") {
          filter.createdDateRange = {
            from: new Date(filterValue),
            to: filter.createdDateRange?.to,
          };
        } else if (filterKey === "createdDate" && condition === "$lte") {
          filter.createdDateRange = {
            to: new Date(filterValue),
            from: filter.createdDateRange?.from,
          };
        }
      }
    }
  });

  return filter;
}
